import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, Checkbox, Divider, Grid, Link, Paper, svgIconClasses, TextField, Toolbar } from "@mui/material";
import Box from "@mui/material/Box";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import SettingsIcon from "@mui/icons-material/Settings";
import { useDispatch, useSelector } from "react-redux";
import { fetchCarryScore, updateCarryScore } from "../../actions/carryScore";
import { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { makeStyles } from "@mui/styles";
import { fetchMasterWorkload } from "../../actions/pickList";
import AddIcon from "@mui/icons-material/Add";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { updatePlanning } from "../../actions/planning";
import Search from "@mui/icons-material/Search";
import {
    InputAdornment,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import { ReactComponent as BtnX } from "../../assets/images/plus-circle-fill.svg";
import planning from "../../services/planning.service";
import { ReactComponent as ChevronExpandDown } from "../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../assets/icons/chevron-expand-up.svg";


function ManageWorkload(props) {
    const { t } = useTranslation()
    const { onClose, selectedValue, open, rubricCat, globalComponentData, id, row, select, allData } = props;
    const handleClose = () => {
        onClose(selectedValue);
    };
    const dispatch = useDispatch();
    const [componentData, setComponentData] = React.useState({
        selectedItemIndex: [],
        isSelectAllChecked: false,
        scoreTotal: 0
    });
    const [mainData, setMainData] = React.useState({ portfolio: [] });
    const [Data, setData] = React.useState({ portfolio: [] });
    const [rbData, setRbData] = React.useState([]);
    const [selectData, setSelectData] = React.useState([]);
    const [checkEdit, setcheckEdit] = React.useState(false);
    const [checkRequired, setCheckRequired] = React.useState(false);
    const MasterWorkload = useSelector((state) => state.PickListMaster.workload);
    const Planning = useSelector((state) => state.Planning);

    useEffect(() => {
        dispatch(fetchMasterWorkload())
        getMasterWorkload()
    }, []);

    let getMasterWorkload = () => {
        planning.masterWorkload(id).then(
            (response) => {
                let data = JSON.parse(JSON.stringify(response.data.portfolio))
                let sumData = []
                if (allData !== undefined && allData !== null && allData.length > 0) {
                    for (let index = 0; index <= allData.length - 1; index++) {
                        if (allData[index].serial === rubricCat.serial) {
                            for (let order = 0; order <= allData[index]?.rb_condition.length - 1; order++) {
                                if (allData[index]?.rb_condition[order]?.serial !== row.serial) {
                                    sumData = [...sumData, ...allData[index].rb_condition[order].portfolio]
                                }

                            }
                        }
                    }
                }
                for (let index = 0; index <= sumData.length - 1; index++) {
                    data = data.filter((rs) => rs.serial !== sumData[index].serial)
                }
                let selectoData = []
                if (row?.portfolio !== undefined && row?.portfolio !== null && row?.portfolio.length > 0 && data !== undefined && data !== null && data.length > 0) {
                    for (let index = 0; index <= row.portfolio.length - 1; index++) {
                        for (let id = 0; id <= data.length - 1; id++) {
                            if (data[id].required === true && checkRequired === false) {
                                setCheckRequired(true)
                            }
                            if (row.portfolio[index]?.serial === data[id]?.serial) {
                                selectoData.push(data[id])
                            }
                        }
                    }
                    setSelectData(selectoData)
                }
                setMainData({ portfolio: data })
                setData({ portfolio: data })
                setRbData(response?.data)
            });
    }
    let checkData = (data) => {
        let check = selectData.filter((rs) => rs.serial === data.serial)
        if (check !== undefined && check !== null && check.length > 0) {
            return true
        }
        return false
    }
    const onSelectAllChange = () => {
        if (selectData.length === Data?.portfolio.length) {
            setSelectData(selectData.filter((rs) => rs.required === true))
        } else {
            setSelectData(Data?.portfolio)
        }
        setcheckEdit(true)
    }
    const onSelectChange = (data) => {
        let check = selectData.filter((rs) => rs.serial === data.serial)
        if (check !== undefined && check !== null && check.length > 0) {
            setSelectData(selectData.filter((rs) => rs.serial !== data.serial))
        } else {
            setSelectData([...selectData, data])
        }
        setcheckEdit(true)
    }
    const onSavePress = (event) => {
        // save to planning
        select(selectData);
        handleClose();
    }
    const calTotalScore = () => {
        let sum = 0
        if (selectData !== undefined && selectData !== null && selectData.length > 0) {
            for (let index = 0; index <= selectData.length - 1; index++) {
                sum = sum + Number(calculateScore(selectData[index]))
            }
        }
        return sum
    }
    const [search, setSearchValue] = React.useState("");
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };
    useEffect(() => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(mainData.portfolio))
        if (search !== "") {
            result = dataSerach.filter(item => {
                return Object.keys(item).some(key => {
                    if (item["description"]) {
                        return item["description"].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                    return item["description"];
                });
            });
        } else {
            result = dataSerach;
        }
        setData({ portfolio: result });
    }, [search]);
    const useStyles = makeStyles({
        "th-underline": {
            "border-bottom": "2px solid #A0A0A0 !important",
            // "border": "1px solid #A0A0A0 !important",
            "color": "#A0A0A0 !important"
        },
        "td-underline": {
            "border-bottom": "1px solid #E5E5E5 !important",
            // "border": "1px solid #A0A0A0 !important",
            "color": "#404349 !important"
        },
        //   fillBtnx: {
        //     margin: "5px 12px 0 0",
        //     '& > path': {
        //       fill: color
        //     },
        //     '& g > path': {
        //       fill: color
        //     },
        //   },
    });
    const classes = useStyles();
    let calculateScore = (data) => {
        let sum = eval(data.calculate_score)
        let scores = Number.isNaN(Number(sum)) ? 0 : Math.round(sum * 100) / 100
        return scores
    }
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);

    let test = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            Data?.portfolio.sort(function (b, a) {
                if (a[key] > b[key]) {
                    return -1;
                }
                if (b[key] > a[key]) {
                    return 1;
                }
                return 0;
            });
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            Data?.portfolio.sort(function (a, b) {
                if (a[key] > b[key]) {
                    return -1;
                }
                if (b[key] > a[key]) {
                    return 1;
                }
                return 0;
            });
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }
    return (
        <>
            {/* <Grid item lg={12} md={12} m={0} p={3}> */}
            <DialogTitle id="form-add-dialog-title" fontSize="1.3rem">
                <Grid item container id="alert-dialog-title">
                    <Typography variant="h3">
                        เลือกภาระงานและผลงาน
                    </Typography>
                    <Box sx={{ position: "absolute", right: 0, margin: "18px 18px 0  0", top: 0, cursor: "pointer" }} onClick={handleClose}><BtnX /></Box>
                </Grid>
                {/* <Divider sx={{ marginTop: "10px" }}/> */}
            </DialogTitle>
            <DialogContent px={0} pb={0}>
                <Divider />
                <Grid item textAlign="center" pt={4}>
                    <Typography variant="h5" color="#404349" fontWeight={300}>
                        กรุณาเลือกภาระงานและผลงานที่ต้องการเพิ่มในรายละเอียดข้อตกลง {rbData?.rubric_condition?.code} {rbData?.rubric_condition?.nameTh}
                    </Typography>
                </Grid>
                <Box p={4}>
                    <Grid item container>
                        <Grid item>
                            <Typography variant="h5">รายการภาระงานและผลงาน</Typography>
                            <Typography variant="label" fontWeight={300}>
                                {t('label.selectedCount')}: <span style={{ padding: "0 5px" }}> {selectData.length} </span> {t('label.items')}
                            </Typography>
                        </Grid>
                        <Box sx={{ flex: 1 }} />
                    </Grid>
                    <Grid item container pt={2} pb={2}>
                        <Grid item sm={12} xs={12} >
                            <TextField
                                id="input-with-icon-textfield"
                                fullWidth
                                placeholder="ค้นหาจากชื่อภาระงาน, ผลงาน"
                                size="small"
                                sx={{ background: "#fff" }}
                                className="searchTextField-h48"
                                value={search}
                                onChange={handleSearch}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search style={{ color: "#C4C4C4" }} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Paper >
                            <Box sx={{ "background-color": "#FAFAFA", width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 450, width: '100%', overflowY: 'scroll', padding: "0 30px" }}>
                                    <Table stickyHeader aria-label="sticky table" sx={{ "background-color": "#FAFAFA" }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="left" className={classes["th-underline"]} width="60px">
                                                    <Checkbox
                                                        checked={selectData.length === Data?.portfolio.length}
                                                        onChange={onSelectAllChange}
                                                    />
                                                </TableCell>
                                                <TableCell align="left" className={classes["th-underline"]}>
                                                    <Typography style={{ "display": "flex" }}>
                                                        {t('label.code')}
                                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex",cursor: "pointer" }}>
                                                            <ChevronExpandUp onClick={e => test("code", true)} />
                                                            <ChevronExpandDown onClick={e => test("code", false)} />
                                                        </Typography>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="left" className={classes["th-underline"]} >
                                                    <Typography style={{ "display": "flex" }}>
                                                        {t('label.workloadDetail')}
                                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex",cursor: "pointer" }}>
                                                            <ChevronExpandUp onClick={e => test("description", true)} />
                                                            <ChevronExpandDown onClick={e => test("description", false)} />
                                                        </Typography>
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center" className={classes["th-underline"]}>
                                                    <Typography style={{ "display": "flex" }}>
                                                        {t('label.amountOfWork')}
                                                        <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex",cursor: "pointer" }}>
                                                            <ChevronExpandUp onClick={e => test("seq", true)} />
                                                            <ChevronExpandDown onClick={e => test("seq", false)} />
                                                        </Typography>
                                                    </Typography>
                                                </TableCell>
                                                {/* <TableCell align="center" className={classes["th-underline"]}>{t('label.score')}</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Data?.portfolio !== undefined && Data?.portfolio !== null && Data?.portfolio.length > 0 ? Data?.portfolio.map((rowItem, rowItemIndex) => (
                                                <TableRow>
                                                    <TableCell component="th" scope="row" align="left"
                                                        className={Data?.portfolio.length === rowItemIndex + 1 ? "" : classes["td-underline"]}>
                                                        <Checkbox
                                                            onClick={e => onSelectChange(rowItem)}
                                                            checked={checkData(rowItem)}
                                                            disabled={rowItem.required}
                                                            inputProps={{
                                                                'data-rowIndex': rowItemIndex,
                                                                'data-rowData': rowItem,
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row"
                                                        className={Data?.portfolio.length === rowItemIndex + 1 ? "" : classes["td-underline"]}>
                                                        {rowItem.code}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row"
                                                        className={Data?.portfolio.length === rowItemIndex + 1 ? "" : classes["td-underline"]}>
                                                        {rowItem.required ? <span>{rowItem.description}<span fontStyle="italic" style={{ fontWeight: 200, color: "#CC6058 " }}> *</span> </span> : rowItem.description}
                                                        <br />
                                                        <Typography variant="dashed-solid"
                                                            pr={1}
                                                            pl={1}
                                                            sx={{
                                                                'display': rowItem.optional !== undefined && rowItem.optional !== null && rowItem.optional !== "" ? 'inline' : 'none',
                                                                'border': '1px solid #393939',
                                                                'borderRadius': '4px',
                                                                'fontSize': '13px',
                                                                // 'padding-left': '5px',
                                                                // 'padding-right': '5px'
                                                            }}>{rowItem.optional}</Typography>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row"
                                                        className={classes["td-underline"]}>
                                                        {rowItem.quantity} {rowItem?.unit?.description}
                                                    </TableCell>
                                                    {/* <TableCell component="th" scope="row" sx={{ "text-align": "center" }}
                                                        className={Data?.portfolio.length === rowItemIndex + 1 ? "" : classes["td-underline"]}>
                                                        {calculateScore(rowItem)}
                                                    </TableCell> */}
                                                </TableRow>
                                            ))
                                                :
                                                <TableRow sx={{ "box-shadow": "none", "background-color": "transparent" }} component={Paper}>
                                                    <TableCell colSpan={8} align="center" >
                                                        ไม่พบข้อมูล</TableCell>
                                                </TableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Paper>
                    </Grid>
                    {/* <Grid item container justifyContent="end" pt={2}>
                        <Typography pr={4}>{t('label.scoreTotal')}</Typography>
                        <Typography pr={4} color="primary">{calTotalScore()}</Typography>
                        <Typography>{t('label.score')}</Typography>
                    </Grid> */}
                    {checkRequired === true ?
                        <Grid item container justifyContent="start" pt={1}>
                            <Typography fontWeight={300} sx={{ display: "flex", color: "#C4C4C4" }}><Box fontStyle="italic" sx={{ fontWeight: 200, marginRight: "5px", color: "#CC6058 " }}>* </Box> ระบบได้เลือกภาระงานและผลงานตั้งต้นตามเกณฑ์และเงื่อนไข ดังนั้นจะไม่สามารถแก้ไขข้อมูลดังกล่าวได้</Typography>
                        </Grid>
                        : null}
                </Box>
                <Grid item container justifyContent="center">
                    <Grid item pr={4}>
                        <Button variant="outlined" onClick={handleClose}>
                            {t('label.cancel')}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button variant="contained" onClick={onSavePress} disabled={checkEdit === true ? false : true}>
                            {t('label.save')}
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
            {/* </Grid> */}
        </>
    );
}
function SimpleDialog(props) {

    const { onClose, selectedValue, open, rubricCat, globalComponentData, id, row, select, allData } = props;
    const handleClose = () => {
        onClose(selectedValue);
    };
    const handleListItemClick = (value) => {
        onClose(value);
    };
    let selectWorkLoad = (value) => {
        select(value);
    }
    return (
        <Dialog onBackdropClick={() => {return false}} onClose={handleClose} open={open} maxWidth='lg' fullWidth>
            <ManageWorkload onClose={handleClose} open={open} rubricCat={rubricCat} row={row} id={id} select={selectWorkLoad} allData={allData}
                globalComponentData={globalComponentData}
            />
        </Dialog>
    );
}
SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
export default function DialogManageWorkload(props) {
    const useStyles = makeStyles({
        fillBlack: {
            '& > path': {
                fill: '#404349'
            },
            '& g > path': {
                fill: '#404349'
            },
        },
    });
    const styles = {
        iconBox: {
            width: "18px",
            height: "18px",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            marginRight: "9px"
        },
    }
    const classes = useStyles()
    const { t } = useTranslation();
    const { rubricCat, itemIndex, type, id, row, select, allData, openWorkload, closeWorkload } = props;
    const [open, setOpen] = React.useState(false);
    const [globalComponentData, setGlobalComponentData] = React.useState({
        rubricCat: "",
        itemIndex: ""
    });
    useEffect(() => {
        let check = openWorkload !== null && openWorkload !== null && openWorkload !== "" ? openWorkload : "****"
        if (check === id) {
            setOpen(true)
        }
    }, [openWorkload, props.openWorkload]);
    const handleClickOpen = () => {
        const oData = {
            rubricCat: rubricCat,
            itemIndex: itemIndex
        }
        setGlobalComponentData(oData)
        setOpen(true);
    };
    const handleClose = (value) => {
        closeWorkload()
        setOpen(false);
    };
    let selectWorkLoad = (value) => {
        closeWorkload()
        select(value, id);
    }
    return (
        <>
            {/*<Button variant="dashed-solid" sx={{'border': '1px solid #393939'}}>{t('planning.label.manageWorkload')}</Button>*/}
            {type === "menuText" ?
                <Typography onClick={handleClickOpen} sx={{ display: "flex", alignItems: "center" }}>
                    <Box style={styles.iconBox} >
                        <AddIcon />
                    </Box>
                    {t('planning.label.manageWorkload')}
                </Typography>
                :
                <Button
                    sx={{ 'border': '1px solid #393939' }}
                    variant="dashed-solid" onClick={handleClickOpen}>เลือกภาระงานและผลงาน</Button>
            }

            <SimpleDialog
                rubricCat={rubricCat}
                globalComponentData={globalComponentData}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                id={id}
                row={row}
                select={selectWorkLoad}
                allData={allData}
            />
        </>
    );
}
